export type FormOperations = "CREATE" | "UPDATE";

export enum RoleName {
  Installer = "Installer",
  HotelViewer = "Hotel Viewer",
  WarehouseStaff = "Warehouse Staff",
  ProjectCoordinator = "Project Coordinator",
}
